import React from "react";
import { useNavigate } from "react-router-dom";

export const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
            <div className="text-center max-w-md w-full bg-white shadow-xl rounded-2xl p-8 border border-gray-100 transform transition-all duration-300 hover:shadow-2xl">
                
                {/* Contenedor del Icono con Animación */}
                <div className="flex items-center justify-center mb-6">
                    <div className="bg-red-50 p-6 rounded-full border border-red-100 relative animate-bounce duration-1000">
                        <i className="fas fa-exclamation-triangle text-red-500 text-5xl"></i>
                    </div>
                </div>

                {/* Código de Error */}
                <h1 className="text-7xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600 mb-2">
                    404
                </h1>

                {/* Mensajes */}
                <h2 className="text-2xl font-bold text-gray-800 mb-3">
                    Página no encontrada
                </h2>
                <p className="text-gray-600 text-sm mb-8 leading-relaxed">
                    Lo sentimos, la ruta a la que estás intentando acceder no existe o fue movida. ¡Asegúrate de que la dirección sea la correcta!
                </p>

                {/* Botón de Retorno con Efectos */}
                <button
                    onClick={() => navigate("/")}
                    className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-all duration-200 flex items-center justify-center space-x-2 shadow-md hover:shadow-lg transform hover:scale-105"
                >
                    <i className="fas fa-arrow-left"></i>
                    <span>Volver al Dashboard</span>
                </button>
            </div>

            {/* Pequeño detalle inferior decorativo */}
            <div className="mt-8 text-center text-gray-400 text-xs">
                <p>© {new Date().getFullYear()} TodoList Pro — Todos los derechos reservados.</p>
            </div>
        </div>
    );
};